import { Space, Modal, Button } from 'antd';
import { FC, useEffect, useState, Key } from 'react';

import styles from './index.module.scss';

import DeviceModal from './DeviceModal';
import { IotProtocolType } from '@/shared/types';

export interface SelectDevicesProps {
  value?: Key[];
  onChange?: (value: Key[]) => void;
  rootMcid?: string;
  type?: number[];
  iotProtocol?: IotProtocolType;
  deviceTypeId?: number;
  objectModalType?: number;
}

const SelectDevices: FC<SelectDevicesProps> = ({
  value,
  onChange,
  rootMcid,
  type,
  deviceTypeId,
  iotProtocol,
  objectModalType,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const [dataSource, setDataSource] = useState<Key[]>([]);
  const [modalApi, modalContextHolder] = Modal.useModal();

  useEffect(() => {
    setDataSource(value ?? []);
  }, [value]);

  const onAdd = () => {
    if (rootMcid === undefined) {
      modalApi.warning({
        title: '请先选择所属租户',
      });
      return;
    }
    if (iotProtocol === undefined) {
      modalApi.warning({
        title: '请先选择物联层协议',
      });
      return;
    }
    if (iotProtocol === IotProtocolType.MOCKINGBIRD && deviceTypeId === undefined) {
      modalApi.warning({
        title: '请先选择适用设备类目',
      });
      return;
    }
    setVisible(true);
  };

  const onCancel = () => {
    setDataSource(value ?? []);
    setVisible(false);
  };

  const onOk = () => {
    onChange?.(dataSource);
    setVisible(false);
  };

  return (
    <>
      <Space>
        <div>
          <span>已选择</span>
          <span className={styles.count}>{value?.length || 0}</span>
          <span>个设备</span>
        </div>
        <Button type="link" onClick={onAdd}>
          继续选择
        </Button>
      </Space>
      <Modal
        className={styles.modal}
        title="设备选择"
        destroyOnClose
        open={visible}
        onOk={onOk}
        onCancel={onCancel}
        width={900}
      >
        <DeviceModal
          objectModalType={objectModalType}
          rootMcid={rootMcid}
          type={type}
          iotProtocol={iotProtocol}
          deviceTypeId={deviceTypeId}
          onChange={setDataSource}
          value={dataSource}
        />
      </Modal>
      {modalContextHolder}
    </>
  );
};

export default SelectDevices;
